// extracted by mini-css-extract-plugin
module.exports = {"activity":"EditPackage_activity__LaBWA","activityNotDraggable":"EditPackage_activityNotDraggable__AHDaq"};